
import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { Addon, FlattenedAddon, AddonOption, GetAddonsOptions, OptionValueEntityInstance } from 'app/shared/models/booking.model';

@Injectable()
export class AddonsService {

    constructor(private readonly http: Http) {}

    getAddons = (options: GetAddonsOptions) => {
        return this.http.post('/umbraco/api/booking/addons', options, null);
    }

    getPassGetAddonsOptions = (total, productRef) => {
        return new GetAddonsOptions( productRef, total, 1);
    }

    getExpressGetAddonsOptions = (total, fuelSurcharge, passengersQty, isReturn) => {
        const options = new GetAddonsOptions(GxConstants.PRODUCTS_REF.EXPRESS, total, passengersQty);
        options.FuelSurcharge = fuelSurcharge;
        options.IsReturn = isReturn;
        return options;
    }

    getAddonsAnswers = (addons: Array<Addon>) => {
        var answers = [];
        _.each(addons,
            addon => {

                //and for each question...
                _.each(addon.AddonOptions,
                    option => {
                        const answer = this.getAnswer(option);
                        if (answer) {
                            const productCode = addon.AddonType === GxConstants.FARETYPE_CODES.THIRD_PARTY
                                      ? answer.productCode
                                      : null,
                                type = addon.AddonType,
                                quantity = 1,
                                salePriceUnit = answer.salePriceUnit,
                                usageDate = option.UsageDate;
                            let result = new FlattenedAddon(productCode, salePriceUnit);
                            result.Type = type;
                            result.quantity = quantity;
                            result.usageDate = usageDate;
                                answers.push(result);
                        }

                    });
            });

        return answers;
    }

    private getAnswer = (option: AddonOption) => {
        if (option.FieldType === GxConstants.FIELD_TYPE.CHECKBOX) {
            if (option.Selected) {
                return new FlattenedAddon(option.ProductCode, option.OptionValueEntity[0].SalePriceUnit);
            };
        }
        if (option.FieldType === GxConstants.FIELD_TYPE.RADIO) {
            if (!!option.UserSelection) {
                return new FlattenedAddon(option.UserSelection.ProductCode, option.UserSelection.SalePriceUnit);
            }
        }
//        throw new Error(`answer handler for fieldType '${option.FieldType}' has not being implemented.`);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/addons.service.ts